import { Breadcrumb } from "react-bootstrap";
import { t } from "i18next";
import { Folder } from "../../../../interfaces/folder";

interface BreadcrumbNavProps {
    path: Folder[];
    onNavigate: (index: number) => void;
}

export function BreadcrumbNav({ path, onNavigate }: BreadcrumbNavProps) {
    // Ensure path is always an array and filter out root element (id: null)
    const safePath = Array.isArray(path) ? path.filter(f => f.id !== null) : [];

    return (
        <Breadcrumb>
            <Breadcrumb.Item
                active={safePath.length === 0}
                onClick={() => onNavigate(-1)}
                style={{ cursor: 'pointer' }}
            >
                <i className="bi bi-house-door me-1"></i>
                {t('My Documents')}
            </Breadcrumb.Item>

            {safePath.map((folder, index) => (
                <Breadcrumb.Item
                    key={folder.id}
                    active={index === safePath.length - 1}
                    onClick={() => onNavigate(index)}
                    style={{ cursor: 'pointer' }}
                >
                    {folder.name}
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
}
